import { Label } from 'components/Label';
import { ScenarioState } from 'data/generated';
import styled from 'styled-components';
import { Colors } from 'styles/colors';

function getScenarioStateTagColors(state: ScenarioState): {
    tagColor: string;
    tagTextColor?: string;
} {
    switch (state) {
        case ScenarioState.Archived:
            return { tagColor: Colors.secondary.darkGrey };
        case ScenarioState.InDevelopment:
            return { tagColor: Colors.secondary.yellow };
        case ScenarioState.Regular:
            return { tagColor: Colors.secondary.green };
    }
}

export const ScenarioStateTag = ({ state, label }: { state: ScenarioState; label?: string }) => {
    const { tagColor, tagTextColor = Colors.primary.white } = getScenarioStateTagColors(state);
    return (
        <Container>
            {label && <Label>{label}</Label>}
            <Tag tagColor={tagColor} tagTextColor={tagTextColor}>
                {state}
            </Tag>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const Tag = styled.div<{ tagColor: string; tagTextColor: string }>`
    font-size: 14px;
    color: ${({ tagTextColor }) => tagTextColor};
    background-color: ${({ tagColor }) => tagColor};
    width: min-content;
    padding: 5px 10px;
    border-radius: 10px;
`;
